import { useValue } from '@morningtrain/react-resources'
import { useTranslation } from '@morningtrain/react-translations'
import React from 'react'
import PropTypes from 'prop-types'

export function CountDisplay (props) {
  const defaultValueRef = React.useRef([])
  const defaultValue = defaultValueRef.current

  const {
    name,
    translationName,
    capitalize = true
  } = props

  const value = useValue(name, defaultValue) ?? defaultValue

  let modelName = useTranslation(['models', translationName, (value.length === 1 ? 'singular' : 'plural')].join('.'))

  if (capitalize && typeof modelName === 'string') {
    modelName = modelName.charAt(0).toUpperCase() + modelName.slice(1)
  }

  return (
    <div>
      {value.length} {modelName}
    </div>
  )
}

CountDisplay.defaultProps = {}

CountDisplay.propTypes = {
  name: PropTypes.string,
  translationName: PropTypes.string,
  capitalize: PropTypes.bool
}

export default CountDisplay
